export default __webpack_public_path__ + "static/waxslice-c6a5d644d0431c25b127b58c63feb742.png";